import * as React from 'react';
import MobileStepper from '@mui/material/MobileStepper';
import PropTypes from "prop-types";
import "./progressBarStepper.scss";

export default function ProgressBarStepper({totalSteps, activeStep}) {
    return (
        <MobileStepper
            variant="progress"
            steps={totalSteps}
            position="static"
            activeStep={activeStep}
        />
    );
}
ProgressBarStepper.prototype = {
    totalSteps: PropTypes.number,
    activeStep: PropTypes.number
}